import script from "./OldApp.vue?vue&type=script&setup=true&lang=js"
export * from "./OldApp.vue?vue&type=script&setup=true&lang=js"

import "./OldApp.vue?vue&type=style&index=0&id=6790b6c8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6790b6c8"]])

export default __exports__